export default class GeneratorFactory {
    constructor(generatorFactory) {
        this.generatorFactory = generatorFactory;
    }
    [Symbol.iterator]() {
        return this.generatorFactory();
    }
    create() {
        return this.generatorFactory();
    }
}
//# sourceMappingURL=GeneratorFactory.js.map